"use client"

import Image from "next/image"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { ShoppingCart } from "lucide-react"

const gameProducts = [
    {
        id: 1,
        title: "هدست مخصوص بازی اونیکوما مدل X-P5 RGB",
        price: 2400000,
        image: "/gallery/banner6.jpg",
        discount: 28,
        endTime: new Date("2024-03-25"),
    },
    {
        id: 2,
        title: "ساعت مچی عقربه‌ای مردانه تایمکس مدل TW2V75800",
        price: 3200000,
        image: "/gallery/banner.jpg",
        discount: 24,
        endTime: new Date("2024-03-24"),
    },
    {
        id: 3,
        title: "لپ تاپ ۱۵.۶ اینچی ایسوس مدل Victus 15 FA1-9DX-15 i5 8GB",
        price: 5400000,
        image: "/gallery/banner2.jpg",
        discount: 24,
        endTime: new Date("2024-03-23"),
    },
    {
        id: 4,
        title: "گوشی موبایل سامسونگ مدل Galaxy A54 5G دو سیم کارت",
        price: 8450000,
        image: "/gallery/banner3.jpg",
        discount: 29,
        endTime: new Date("2024-03-22"),
    },
    {
        id: 5,
        title: "گوشی موبایل سامسونگ مدل Galaxy A54 5G دو سیم کارت",
        price: 8450000,
        image: "/gallery/banner4.jpg",
        discount: 29,
        endTime: new Date("2024-03-22"),
    },
    {
        id: 6,
        title: "گوشی موبایل سامسونگ مدل Galaxy A54 5G دو سیم کارت",
        price: 8450000,
        image: "/gallery/banner5.jpg",
        discount: 29,
        endTime: new Date("2024-03-22"),
    },
    {
        id: 7,
        title: "گوشی موبایل سامسونگ مدل Galaxy A54 5G دو سیم کارت",
        price: 8450000,
        image: "/gallery/5.webp",
        discount: 29,
        endTime: new Date("2024-03-22"),
    }
]

export function ProductCardWithTimer() {
    return (
        <div className="relative w-full">
            <div className="grid grid-cols-12 gap-4 md:gap-12 relative">
                {/* Background */}
                <div className="absolute inset-0 w-full h-full md:h-[260px] bg-primary/10 rounded-3xl my-auto"></div>

                {/* Timer */}
                <div className="relative md:col-span-2 col-span-12 flex items-center justify-center z-20 h-full md:h-[300px] py-6 md:py-12 px-6 md:px-0 my-auto">
                    {/* Timer bottomn vector */}
                    <div className="absolute bottom-0 left-0 transform -translate-x-8 md:-translate-x-16 -translate-y-2 hidden md:block">
                        <svg className="w-16 md:w-32" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121.08 24.06">
                            <g id="Layer_1-2" data-name="Layer 1">
                                <g id="Layer_1-2" data-name="Layer 1-2">
                                    <path
                                        fill="#0A0512"
                                        d="m0,24.06c18.7-2.54,31.38-8.52,39.6-13.64C48.08,5.14,53.08,0,61.77,0s13.44,5.06,22.55,10.61c7.98,4.86,19.88,10.49,36.76,13.45" />
                                </g>
                            </g>
                        </svg>
                    </div>

                    <div className="absolute bottom-0 left-0 transform -translate-x-16 md:-translate-x-16 -translate-y-3 rotate-90 block md:hidden">
                        <svg className="w-32" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121.08 24.06">
                            <g id="Layer_1-2" data-name="Layer 1">
                                <g id="Layer_1-2" data-name="Layer 1-2">
                                    <path
                                        fill="#0A0512"
                                        d="m0,24.06c18.7-2.54,31.38-8.52,39.6-13.64C48.08,5.14,53.08,0,61.77,0s13.44,5.06,22.55,10.61c7.98,4.86,19.88,10.49,36.76,13.45" />
                                </g>
                            </g>
                        </svg>
                    </div>

                    <div className="absolute bottom-0 right-0 transform translate-x-16 md:translate-x-16 -translate-y-3 -rotate-90 block md:hidden">
                        <svg className="w-32" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121.08 24.06">
                            <g id="Layer_1-2" data-name="Layer 1">
                                <g id="Layer_1-2" data-name="Layer 1-2">
                                    <path
                                        fill="#0A0512"
                                        d="m0,24.06c18.7-2.54,31.38-8.52,39.6-13.64C48.08,5.14,53.08,0,61.77,0s13.44,5.06,22.55,10.61c7.98,4.86,19.88,10.49,36.76,13.45" />
                                </g>
                            </g>
                        </svg>
                    </div>

                    {/* Timer top vector */}
                    <div className="absolute top-0 left-0 transform -translate-x-8 md:-translate-x-16 translate-y-2 hidden md:block">
                        <svg className="w-16 md:w-32" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 121.08 24.06">
                            <g id="Layer_1-2" data-name="Layer 1">
                                <g id="Layer_1-2" data-name="Layer 1-2">
                                    <path
                                        fill="#0A0512"
                                        d="m0,0c18.7,2.54,31.38,8.52,39.6,13.64,8.48,5.28,13.48,10.42,22.17,10.42s13.44-5.06,22.55-10.61c7.98-4.86,19.88-10.49,36.76-13.45" />
                                </g>
                            </g>
                        </svg>
                    </div>

                    {/* Timer content */}
                    <div className="md:border-l-2 border-b-2 md:border-b-0 pb-10 md:pb-0 border-dashed border-border/70  w-full h-full flex flex-col items-center justify-center text-center gap-1 md:gap-2">
                        <h3 className="text-lg md:text-2xl font-bold text-purple-500">پیشنهــــاد<br />شگفت‌انگیز!</h3>
                        <div className="flex flex-col items-center gap-0.5 md:gap-1">
                            <div className="flex items-center gap-1 text-base md:text-lg">
                                <span className="text-purple-500">۲۴</span>
                                <span className="text-xs md:text-sm text-muted-foreground">:</span>
                                <span className="text-purple-500">۰</span>
                                <span className="text-xs md:text-sm text-muted-foreground">:</span>
                                <span className="text-purple-500">۳۲</span>
                            </div>
                            <div className="flex items-center gap-2 text-xs text-muted-foreground">
                                <span>ساعت</span>
                                <span>دقیقه</span>
                                <span>ثانیه</span>
                            </div>
                        </div>
                        <button className="mt-2 px-4 py-1 text-sm text-white bg-purple-500 rounded-full hover:bg-purple-600 transition-colors">
                            مشاهده محصولات
                        </button>
                    </div>
                </div>

                {/* Products */}
                <div className="md:col-span-10 col-span-12 relative z-20 p-8 md:p-0">
                    {/* Shadow overlay on the left */}
                    <div className="absolute left-0 top-0 h-full w-32 bg-gradient-to-l  from-transparent to-background z-20 hidden md:block" />

                    {/* Shadow overlay on the right */}
                    {/* <div className="absolute right-0 top-0 h-full w-32  md:bg-gradient-to-r from-transparent to-background z-20" /> */}
                    <Swiper
                        modules={[Navigation, Pagination]}
                        loop={true}
                        grabCursor={true}
                        autoplay={{
                            delay: 2500,
                            pauseOnMouseEnter: true
                        }}
                        breakpoints={{
                            0: {
                                slidesPerView: 1,
                                spaceBetween: 14,
                            },
                            480: {
                                slidesPerView: 2,
                                spaceBetween: 16,
                            },
                            640: {
                                slidesPerView: 3,
                                spaceBetween: 16,
                            },
                            768: {
                                slidesPerView: 4,
                                spaceBetween: 20,
                            },
                            1024: {
                                slidesPerView: 5,
                                spaceBetween: 20,
                            }
                        }}
                        className="px-4 md:px-0"
                    >
                        {gameProducts.map((product) => (
                            <SwiperSlide key={product.id}>
                                <div className="group relative flex flex-col overflow-hidden md:rounded-lg rounded-2xl border border-border/50 bg-card">
                                    {product.discount && (
                                        <div className="absolute right-2 md:right-3 top-2 md:top-3 z-20 rounded-full bg-purple-500 px-2 md:px-3 py-0.5 md:py-1 text-[10px] md:text-xs font-medium text-white">
                                            {product.discount}٪
                                        </div>
                                    )}

                                    <div className="relative aspect-square overflow-hidden">
                                        <Image
                                            src={product.image}
                                            alt={product.title}
                                            fill
                                            className="object-cover transition-transform duration-300 group-hover:scale-105"
                                        />
                                    </div>

                                    <div className="flex flex-1 flex-col text-center items-center space-y-2 md:space-y-3 p-3 md:p-4">
                                        <h3 className="text-[10px] md:text-xs font-medium text-foreground/90 line-clamp-2">
                                            {product.title}
                                        </h3>

                                        <div className="flex items-center justify-between w-full">
                                            <div className="flex items-center gap-1 md:gap-1.5">
                                                <span className="text-sm md:text-md font-bold text-purple-500">
                                                    {product.price.toLocaleString()}
                                                </span>
                                                <span className="text-[10px] md:text-sm text-muted-foreground">تومان</span>
                                            </div>
                                        </div>

                                        <div className="grid grid-cols-4 gap-1 md:gap-1.5 text-center w-full">
                                            <div className="flex flex-col items-center gap-0.5 md:gap-1">
                                                <span className="text-xs md:text-sm rounded-sm bg-muted/80 pt-[0.7px] w-full">۱۰</span>
                                                <span className="text-[10px] md:text-xs text-muted-foreground">ثانیه</span>
                                            </div>
                                            <div className="flex flex-col items-center gap-0.5 md:gap-1">
                                                <span className="text-xs md:text-sm rounded-sm bg-muted/80 pt-[0.7px] w-full">۶</span>
                                                <span className="text-[10px] md:text-xs text-muted-foreground">دقیقه</span>
                                            </div>
                                            <div className="flex flex-col items-center gap-0.5 md:gap-1">
                                                <span className="text-xs md:text-sm rounded-sm bg-muted/80 pt-[0.7px] w-full">۱۰</span>
                                                <span className="text-[10px] md:text-xs text-muted-foreground">ساعت</span>
                                            </div>
                                            <div className="flex flex-col items-center gap-0.5 md:gap-1">
                                                <span className="text-xs md:text-sm rounded-sm bg-muted/80 pt-[0.7px] w-full">۲۰</span>
                                                <span className="text-[10px] md:text-xs text-muted-foreground">روز</span>
                                            </div>
                                        </div>

                                        <Button
                                            variant='outline'
                                            className="w-full gap-x-1 md:gap-x-2 hover:bg-primary text-white text-xs md:text-sm"
                                            size="sm"
                                        >
                                            <ShoppingCart className="h-3 w-3 md:h-4 md:w-4" />
                                            افزودن به سبد خرید
                                        </Button>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </div>
    )
} 